import {
  DEFAULT_PLAYER_GAME_ORDERING,
  baseFetchPlayerSpanStats,
  baseFetchPlayerGameStats,
  baseFetchPlayerStreakStats,
  baseFetchTeamGameStats,
} from './api';
import API_URLS from './api_urls';

export const fetchWnbaPlayerSpanStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchPlayerSpanStats(
  API_URLS.wnba.player_span_finder, filters, signOut, page, sortBy, uuid
);

export const fetchWnbaPlayerGameStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchPlayerGameStats(API_URLS.wnba.player_game_finder, filters, signOut, page, sortBy, uuid)

export const fetchWnbaPlayerStreakStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchPlayerStreakStats(
  API_URLS.wnba.player_streak_finder, filters, signOut, page, sortBy, uuid
);

export const fetchWnbaTeamGameStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchTeamGameStats(
  API_URLS.wnba.team_game_finder, filters, signOut, page, sortBy, uuid
);

export const fetchWnbaTeamStreakStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchTeamGameStats(
  API_URLS.wnba.team_streak_finder, filters, signOut, page, sortBy, uuid
);

export const fetchWnbaTeamSpanStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchTeamGameStats(
  API_URLS.wnba.team_span_finder, filters, signOut, page, sortBy, uuid
);
